<template>
  <!--
    readExcelData: function(rowNumber, cells, dataTypes, func) excel data 읽을 때 사용
      - rowNumber: 현재 row number
      - cells: 현재 row 의 cell data
      - dataTypes: tableDataType, 사용자가 임의로 정하는 타입
      - func: ExcelUploadNormalTemplate.vue 의 method
        - func.save(cells, error) excel data 저장
        - func.findFieldByFieldName(fieldName) fieldName 으로 field 찾기, useFieldCell 이 true 일때만 사용
        - func.toTel(string) string 을 전화번호 타입으로 변경

    setSaveFormData
  -->
  <normal-excel-upload
    :board="board"
    title="적격수급인 현황 엑셀 업로드"
    :useFieldCell="false"
    :useCompanyCell="true"
    :downloadLink="downloadLink"
    tableTitle="적격수급인 현황"
    :tableHeader="tableHeader"
    :tableDataType="tableDataType"
    :readExcelData="readExcelData"
    :setSaveFormData="setSaveFormData"
  >
    <template #colgroup>
      <col width="100px" />
      <col width="100px" />
      <col width="120px" />
      <col width="140px" />
      <col width="100px" />
      <col width="100px" />
      <col width="120px" />
      <col width="120px" />
      <col width="120px" />
      <col width="120px" />
    </template>

    <!--
      index: column index
      data: column data
      dataType: 사용자가 임의로 정하는 타입
      funcSetEditExcelData: function(index, data, errorMSG) edit excel data 수정시 사용
        - errorMGS = "": 정상
        - errorMGS = "error message": 에러 메시지
        - errorMGS = undefined: 에러 메시지 변경안함
    -->
    <template v-slot:edit="{ index, data, dataType, funcSetEditExcelData }">
      <fragment v-if="dataType === 'no'">{{ data }}</fragment>
      <fragment v-else-if="dataType === 'company'">
        <company-selector class="w-full" v-model="data.id" @select="(company) => onSelectCompany(company, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else-if="dataType === 'year'">
        <ml-input class="w-full" type="number" :value="data" :max-value="9999" :min-value="2000" @input="(number) => funcSetEditExcelData(index, number, '')" />
      </fragment>
      <fragment v-else-if="dataType === 'radio2'">
        <div class="grid gap-2 text-left">
          <vs-radio :value="data" :vs-name="tableHeader[index]" vs-value="@08" @input="(value) => funcSetEditExcelData(index, value, '')">통과 </vs-radio>
          <vs-radio :value="data" :vs-name="tableHeader[index]" vs-value="@0A" @input="(value) => funcSetEditExcelData(index, value, '')">미통과 </vs-radio>
        </div>
      </fragment>
      <fragment v-else-if="dataType === 'radio3'">
        <div class="grid gap-2 text-left">
          <vs-radio :value="data" :vs-name="tableHeader[index]" vs-value="@08" @input="(value) => funcSetEditExcelData(index, value, '')">통과 </vs-radio>
          <vs-radio :value="data" :vs-name="tableHeader[index]" vs-value="@0A" @input="(value) => funcSetEditExcelData(index, value, '')">미통과 </vs-radio>
          <vs-radio :value="data" :vs-name="tableHeader[index]" vs-value="@EB@" @input="(value) => funcSetEditExcelData(index, value, '')">해당없음 </vs-radio>
        </div>
      </fragment>
      <fragment v-else>
        <ml-input class="w-full" :value="data" @input="(value) => funcSetEditExcelData(index, value, '')" />
      </fragment>
    </template>
    <template v-slot:column="{ index, data, dataType }">
      <p v-if="dataType === 'company'">{{ data.com_name || "-" }}</p>
      <p v-else-if="['radio2', 'radio3'].indexOf(dataType) >= 0" :style="{ color: getResultColor(data) }">
        {{ getResult(data) }}
      </p>
      <p v-else>{{ data || "-" }}</p>
    </template>
  </normal-excel-upload>
</template>

<script>
import NormalExcelUpload from "@/views/excel-upload/NormalExcelUpload.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import config from "/public/config";
import CompanySelector from "@/components/selector/CompanySelector.vue";

export default {
  components: {
    CompanySelector,
    DateSelector,
    NormalExcelUpload,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%EC%A0%81%EA%B2%A9%EC%88%98%EA%B8%89%EC%9D%B8_%EA%B4%80%EB%A6%AC%ED%98%84%ED%99%A9_%EB%8C%80%EB%9F%89%EB%93%B1%EB%A1%9D_2.xlsx`,
      tableDataType: ["no", "year", "company", "string", "radio2", "radio3", "radio3", "radio3", "radio3", "radio3", "radio3"],
      tableHeader: ["No.", "연도", "업체명", "사업자등록번호", "안전자격제 통과여부", "중대재해발생여부확인서", "원천징수이행상황신고서", "산재요양승인반려여부확인서", "안전보건조직도", "안전보건경영방침", "안전보건관리규정"],
      // 실제 form.subInfo 에 저장되는 데이터이므로 no 를 사용하지 않습니다.
      tableDataValue: [
        "구분",
        "연도",
        "설비명",
        "업체명",
        "사업자등록번호",
        "안전자격제통과여부",
        "안전자격제통과여부",
        "중대재해발생여부확인서",
        "원천징수이행상황신고서",
        "산재요양승인반려여부확인서",
        "안전보건조직도",
        "안전보건경영방침",
        "안전보건관리규정",
      ],
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  methods: {
    getResultColor(data) {
      const color = {
        "@08": "#28C76F",
        "@0A": "#EA5455",
        "@EB@": "#696D71",
      };
      return color[data] || "";
    },
    getResult(data) {
      const result = {
        "@08": "통과",
        "@0A": "미통과",
        "@EB@": "해당없음",
      };
      return result[data] || "";
    },
    onSelectCompany(company, edit) {
      const data = {
        id: company.id,
        com_name: company.com_name,
      };
      console.log("data", data);
      const errorMSG = company.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      edit.funcSetEditExcelData(edit.index, data, errorMSG);
    },
    onSelectDate(date, index, edit) {
      if (date) {
        const data = new Date(date).format("yyyy-MM-dd");
        const errorMSG = !isNaN(Date.parse(date)) ? "" : "날짜 형식이 아닙니다.";
        edit.funcSetEditExcelData(edit.index, data, errorMSG);
      } else {
        edit.funcSetEditExcelData(edit.index, "", "");
      }
    },
    readExcelData(rowNumber, cells, dataTypes, func) {
      if (rowNumber > 2) {
        const error = [];
        cells.forEach((cell, index) => {
          if (dataTypes[index] === "no") {
            cells[index] = func.rowIndex;
          } else if (dataTypes[index] === "year") {
            const number = Number(cell);
            cells[index] = number;
            if (isNaN(number)) {
              error[index] = "숫자 형식이 아닙니다.";
            }
          } else if (dataTypes[index] === "number") {
            const number = Number(cell);
            cells[index] = number;
            if (isNaN(number)) {
              error[index] = "숫자 형식이 아닙니다.";
            }
          } else if (dataTypes[index] === "company") {
            const company = func.findCompanyByComName(cells[index]);
            if (company) {
              cells[index] = {
                id: company.id,
                com_name: company.com_name,
              };
            } else {
              cells[index] = {
                id: 0,
                com_name: cells[index],
              };
              error[index] = "입력된 데이터가 검색되지 않습니다.";
            }
          } else if (dataTypes[index] === "date") {
            if (cells[index]) {
              if (!isNaN(Date.parse(cells[index]))) {
                cells[index] = new Date(cells[index]).format("yyyy-MM-dd");
              } else {
                error[index] = "날짜 형식이 아닙니다.";
              }
            }
          }
        });

        // cells 이 비어 있을 경우 저장하지 않음
        let emptyCount = 0;
        for (let i = 1; i <= 12; i++) {
          if (i === 3 && !cells[i].com_name) {
            emptyCount++;
          } else if (!cells[i]) {
            emptyCount++;
          }
        }
        if (emptyCount < 12) {
          func.save(cells, error);
        }
      }
    },

    setSaveFormData(datas, stdInfo) {
      console.log(datas);
      const form = {
        stdInfo,
        대상정보: {
          업체명: datas[2],
          사업자등록번호: datas[3],
          안전자격제통과여부: datas[4],
          승인여부: "미승인",
        },
        필수제출서류: {
          중대재해발생여부확인서: datas[5],
          원천징수이행상황신고서: datas[6],
          산재요양승인반려여부확인서: datas[7],
          안전보건조직도: datas[8],
          안전보건경영방침: datas[9],
          안전보건관리규정: datas[10],
        },
      };

      let 승인_count = 0;
      if (["@08", "@EB@"].indexOf(form.대상정보.안전자격제통과여부) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.중대재해발생여부확인서) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.원천징수이행상황신고서) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.산재요양승인반려여부확인서) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.안전보건조직도) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.안전보건경영방침) >= 0) 승인_count++;
      if (["@08", "@EB@"].indexOf(form.필수제출서류.안전보건관리규정) >= 0) 승인_count++;
      form.대상정보.승인여부 = 승인_count === 7 ? "승인" : "미승인";

      const date = new Date();
      const header = {
        year: datas[1],
        month: date.getMonth() + 1,
        date: date.format("yyyy-MM-dd"),
        full: "",
      };
      header.full = new Date(`${header.year}-${header.month}-01`).format("yyyy-MM-dd");

      console.log(header, form);

      return {
        header,
        body: form,
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
